.dropdown {
  display: inline-flex;
  position: relative;
  vertical-align: top;
}

.dropdown-menu {
  display: none;
  left: 0;
  min-width: 12rem;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  z-index: 99;
  transform: scaleY(0.5);
  transition: all .3s ease;
  overflow: hidden;
  box-shadow: 0 6px 16px 0 rgba(0,0,0,.08), 0 3px 6px -4px rgba(0,0,0,.12), 0 9px 28px 8px rgba(0,0,0,.05);
}

.dropdown-content {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  max-width: 300px;
}

.dropdown-divider {
  background-color: #ededed;
  border: none;
  display: block;
  height: 1px;
  margin: 0.5rem 0;
}

.dropdown-item {
  width: 100%;
  color: #4a4a4a;
  display: block;
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.375rem 1rem;
  position: relative;
  cursor: pointer;
}

a.dropdown-item, button.dropdown-item, div.dropdown-item {
  padding-right: 3rem;
  text-align: inherit;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  transition: all .3s;
}
a.dropdown-item:hover, button.dropdown-item:hover, div.dropdown-item:hover {
  color: #fd5000;
}

a.dropdown-item.is-active, button.dropdown-item.is-active,div.dropdown-item.is-active {
  background-color: #fd5000;
  color: #fff;
}

.dropdown.is-active .dropdown-menu, .dropdown.is-hoverable:hover .dropdown-menu,
.dropdown.is-hover:hover .dropdown-menu, .dropdown.is-hoverable:hover .dropdown-menu {
  display: block;
  transform: scaleY(1);
  transition: all .3s ease;
}

.dropdown.is-right .dropdown-menu {
  left: auto;
  right: 0;
}


.dropdown.is-up .dropdown-menu {
  bottom: 100%;
  padding-bottom: 4px;
  padding-top: initial;
  top: auto;
}